import { memo } from "react";
import PropTypes from "prop-types";
import { FormattedMessage } from "react-intl";
import "./FrequencyFlyersMarketing.scss";
import IconSkywards from "app/pages/.shared/IconSkywards";

const FrequencyFlyersMarketing = ({ showPictoOnly }) => {
	return (
		<div className="frequency-flyers-marketing">
			<div className="frequency-flyers-marketing__picto">
				<IconSkywards />
			</div>
			{!showPictoOnly && (
				<div className="frequency-flyers-marketing__label">
					<FormattedMessage id="frequently.flyers.label" />
				</div>
			)}
		</div>
	);
};

FrequencyFlyersMarketing.propTypes = {
	showPictoOnly: PropTypes.bool,
};

export default memo(FrequencyFlyersMarketing);
